module.exports = __webpack_public_path__ + "img/banner6.e68442ed.jpg";